/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The per-line breakdown shows the syllables in each line, which is ideal for poetry. For the 5-7-5 haiku pattern specifically, try the Haiku Checker.`)
};

const es_syl_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. El desglose por línea muestra las sílabas de cada línea, lo cual es ideal para la poesía. Para el patrón de haiku 5-7-5 en concreto, prueba el Verificador de haiku.`)
};

const de_syl_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Die Aufschlüsselung pro Zeile zeigt die Silben in jeder Zeile an, was ideal für Gedichte ist. Für das 5-7-5-Haiku-Muster nutze am besten den Haiku-Prüfer.`)
};

const nl_syl_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. De uitsplitsing per regel toont de lettergrepen in elke regel, wat ideaal is voor poëzie. Probeer voor het specifieke 5-7-5 haikupatroon de Haiku-controle.`)
};

const fr_syl_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Le détail par ligne indique les syllabes de chaque vers, ce qui est idéal pour la poésie. Pour le schéma de haïku 5-7-5 en particulier, essayez le Vérificateur de haïku.`)
};

const it_syl_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Il dettaglio riga per riga mostra le sillabe di ogni riga, il che è ideale per la poesia. Per lo schema haiku 5-7-5 in particolare, prova il Verifica Haiku.`)
};

const pt_br2_syl_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O detalhamento linha por linha mostra as sílabas de cada linha, o que é ideal para poesia. Para o padrão haiku 5-7-5 especificamente, experimente o Verificador de Haiku.`)
};

const pt_syl_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A discriminação linha a linha mostra as sílabas de cada linha, o que é ideal para poesia. Para o padrão haiku 5-7-5 em particular, experimente o Verificador de Haiku.`)
};

const ja_syl_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、できます。行ごとの内訳で各行の音節数が表示されるため、詩の作成に最適です。5-7-5の俳句パターンを特にチェックしたい場合は、俳句チェッカーをお試しください。`)
};

const zh_syl_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。逐行明细会显示每行的音节数，非常适合诗歌创作。如果要专门检测5-7-5的俳句格式，可以试试俳句检测器。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_hub_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_hub_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_hub_faq2_a", locale)
	if (locale === "en") return en_syl_hub_faq2_a(inputs)
	if (locale === "es") return es_syl_hub_faq2_a(inputs)
	if (locale === "de") return de_syl_hub_faq2_a(inputs)
	if (locale === "nl") return nl_syl_hub_faq2_a(inputs)
	if (locale === "fr") return fr_syl_hub_faq2_a(inputs)
	if (locale === "it") return it_syl_hub_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_syl_hub_faq2_a(inputs)
	if (locale === "pt") return pt_syl_hub_faq2_a(inputs)
	if (locale === "ja") return ja_syl_hub_faq2_a(inputs)
	return zh_syl_hub_faq2_a(inputs)
};